/**
 * メインスライダー(Swiper)とサムネイルカルーセルを連動させる
 * - サムネイルクリックでメインスライダーを移動
 * - メインスライダーの切り替えに合わせてアクティブ表示・カルーセル位置を更新
 * - 見切れ側の端にだけフェード(mask-image)をかけるためのクラスを付与
 */
/**
 * 横方向のホイール操作がページ側へ抜けて、画面全体が左右にブレる（バウンス・戻るジェスチャー）のを防ぐ
 * - 横方向が主体のホイールだけ既定動作を止める（スライダー自体の移動は Swiper が処理する）
 * - 縦方向は触らないので、ページのスクロールや記事スクロールへの転送はそのまま
 */
function preventHorizontalOverscroll(elem) {
  if (!elem) return;
  elem.addEventListener(
    'wheel',
    (evt) => {
      if (evt.ctrlKey) return;
      if (Math.abs(evt.deltaX) > Math.abs(evt.deltaY)) evt.preventDefault();
    },
    { passive: false }
  );
}

function initSliderThumbs(main_swiper, thumbs_elem) {
  if (!main_swiper || !thumbs_elem) return null;

  preventHorizontalOverscroll(thumbs_elem);

  const has_single_thumb = thumbs_elem.querySelectorAll('.slider-thumbs__button').length <= 1;
  const thumbs_swiper = new Swiper(thumbs_elem, {
    direction: 'horizontal',
    slidesPerView: 'auto',
    freeMode: true,
    nested: true,
    watchOverflow: true,
    mousewheel: {
      enabled: !has_single_thumb,
      forceToAxis: true,
      releaseOnEdges: true,
    },
    allowTouchMove: !has_single_thumb,
    simulateTouch: !has_single_thumb,
  });

  if (has_single_thumb) {
    thumbs_swiper.disable();
    thumbs_swiper.mousewheel.disable();
    thumbs_swiper.params.mousewheel.enabled = false;
    thumbs_swiper.params.allowTouchMove = false;
    thumbs_swiper.params.simulateTouch = false;
  }

  const getButtons = () => Array.from(thumbs_elem.querySelectorAll('.slider-thumbs__button'));

  const updateEdges = () => {
    thumbs_elem.classList.toggle('is-start', thumbs_swiper.isBeginning);
    thumbs_elem.classList.toggle('is-end', thumbs_swiper.isEnd);
  };

  const setActive = (index) => {
    getButtons().forEach((button, i) => {
      const is_active = i === index;
      button.classList.toggle('is-active', is_active);
      if (is_active) {
        button.setAttribute('aria-current', 'true');
      } else {
        button.removeAttribute('aria-current');
      }
    });
    // アクティブなサムネイルの前後が見えるよう、2つ手前を左端に寄せる
    thumbs_swiper.slideTo(Math.max(0, index - 2));
  };

  thumbs_elem.addEventListener('click', (evt) => {
    const button = evt.target.closest('.slider-thumbs__button');
    if (!button) return;
    const index = getButtons().indexOf(button);
    if (index >= 0) main_swiper.slideTo(index);
  });

  main_swiper.on('slideChange', () => setActive(main_swiper.activeIndex));
  thumbs_swiper.on('progress', updateEdges);
  thumbs_swiper.on('resize', updateEdges);

  setActive(main_swiper.activeIndex);
  updateEdges();

  return thumbs_swiper;
}
